import { render, staticRenderFns } from "./my-orgcompany.vue?vue&type=template&id=88cee592&"
import script from "./my-orgcompany.vue?vue&type=script&lang=js&"
export * from "./my-orgcompany.vue?vue&type=script&lang=js&"
import style0 from "./my-orgcompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports